import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs/Observable';
import { Lookup, AccessCardType, EventType, User, TimeLookup, EventParking, FMUnits, FMMaterialState, FMMaterialPackaging, FMRegisterHazardMaterial, GeneralLookup } from '../models';
import { InvoiceSO, TenantLookup } from '@app/core';


@Injectable()

export class LookupsService extends BaseHttpService<any> {
  constructor(private http: HttpClient) {
    super();
  }

  getCompanyLicenseTypes(): Observable<Lookup[]> {

    return this.http
      .get(this.getApiURI() + "/lookups/GetLicenseTypes")
      .catch(this.handleError)
  }

  getCountries(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetCountries")
      .catch(this.handleError)
  }

  getContactTypes(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetContactTypes")
      .catch(this.handleError)
  }

  getIdTypes(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetIdTypes")
      .catch(this.handleError)
  }

  getVenueTypes(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetVenueTypes")
      .catch(this.handleError)
  }

  getRequestAccessCardReasons(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetRequestAccessCardReasons")
      .catch(this.handleError)
  }

  getAccessCardTypes(): Observable<AccessCardType[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetAccessCardTypes")
      .catch(this.handleError)
  }
  getEventTypes(): Observable<EventType[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetEventTypes")
      .catch(this.handleError)
  }


  getChargesTypes(): Observable<GeneralLookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetChargesType")
      .catch(this.handleError)
  }

  getSOs(): Observable<string[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetSOs")
      .catch(this.handleError)
  }

  getAccessCardCancellationReason(): Observable<EventType[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetAccessCardCancellationReason")
      .catch(this.handleError)
  }




  getChargeTypes(groupId: number): Observable<Lookup[]> {
    let Params = new HttpParams().set('groupId', String(groupId));

    return this.http
      .get(this.getApiURI() + "/lookups/GetChargeTypes", { params: Params })
      .catch(this.handleError)
  }

  /* TODO: Fix the dependency */
  getUsers(): Observable<User[]> {
    return this.http
      .get(this.getApiURI() + "/users")
      .catch(this.handleError)
  }

  getTimeLookup(): TimeLookup[] {
    var timeList: TimeLookup[] = [];

    var timeEntry: TimeLookup;
   
    let time: number = 6;
    let max: number = 12;
    while (time <= max) {
      var symbl = time == 12 ? 'PM' : 'AM';

      timeEntry = new TimeLookup(time, 0, symbl);
      timeList.push(timeEntry)
      timeEntry = new TimeLookup(time, 30, symbl);
      
      timeList.push(timeEntry)
      time++;
    
    }
    

    time = 1;
    max = 10;
    while (time <= max) {
      
      timeEntry = new TimeLookup(time, 0, 'PM');
      timeList.push(timeEntry)
      if (time != max) {
        timeEntry = new TimeLookup(time, 30, 'PM');
        timeList.push(timeEntry)
      } 
      time++; 
    }


    return timeList;
  }


  getParkingNames(): Observable<EventParking[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetEventParking")
      .catch(this.handleError)
  }
  getRequestStatusAll(): Observable<Lookup[]> {

    return this.http
      .get(this.getApiURI() + "/lookups/GetRequestStatusAll")
      .catch(this.handleError)
  }

  getFMUnits(): Observable<FMUnits[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetUnits")
      .catch(this.handleError)
  }

  getFMMaterialState(): Observable<FMMaterialState[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetMaterialState")
      .catch(this.handleError)
  }
  getFMMaterialPackaging(): Observable<FMMaterialPackaging[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetMaterialPackaging")
      .catch(this.handleError)
  }
  getFMTypeofActivity(): Observable<FMMaterialPackaging[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetFMTypeofActivity")
      .catch(this.handleError)
  }
  getFMMaterialLookup(): Observable<FMRegisterHazardMaterial[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetFMRegisteredHazard")
      .catch(this.handleError)
  }
  getFMTransportationMode(): Observable<GeneralLookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetFMTransportationMode")
      .catch(this.handleError)
  }

  getRequestClassification(): Observable<Lookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetRequestClassification")
      .catch(this.handleError)
  }
  getFMDeliveryLocation(): Observable<GeneralLookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetDeliveryLocation")
      .catch(this.handleError)
  }
  getTenants(includeSubmitted: number = 0): Observable<TenantLookup[]> {

    let Params = new HttpParams().set('includeSubmitted', String(includeSubmitted));

    return this.http
      .get(this.getApiURI() + "/lookups/GetTenants", { params: Params })
      .catch(this.handleError)
  }
  getBusinessType(): Observable<GeneralLookup[]> {
    return this.http
      .get(this.getApiURI() + "/lookups/GetBusinessType")
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/lookups.service.ts